
import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
export default function EdgeCasesChecker() {
    const candidate = useSelector((state) => state.currentCandidate);
    const hasCV = candidate?.cv?.hasCv;
    const hasLinkedIn = candidate?.linkedin && candidate?.linkedin.length > 0;
    const hasLinkedInParsed = candidate?.parses && candidate.parses.length > 0 && candidate?.parses?.some(parse => parse?.parseType?.name === 'linkedin');
    const hasCVParsed = candidate?.parses && candidate.parses.length > 0 && candidate?.parses?.some(parse => parse?.parseType?.name === 'cv');

    if(!hasCV && !hasLinkedIn) {
        return (
            <Typography variant="body2" color="error">
                Warning: The candidate has neither a CV uploaded nor a LinkedIn profile linked. AI parsing may not yield optimal results. This may result to low accuracy data. Please consider parsing a CV or a LinkedIn profile first.
            </Typography>
        );
    }

    if(hasLinkedIn && hasLinkedInParsed && hasCV && hasCVParsed) {
        return (
            <Typography variant="body2" color="error">
                Notice: The candidate already has parsed data from both CV and LinkedIn. Proceeding will overwrite existing parsed information.
            </Typography>
        );
    }
    
    if(hasLinkedIn && !hasLinkedInParsed) {
        return (
            <Typography variant="body2" color="error">
                Notice: The candidate has a LinkedIn profile linked but it hasn't been parsed yet. Consider parsing the LinkedIn profile to enrich candidate data.
            </Typography>
        );
    }
    
    if(hasCV && !hasCVParsed) {
        return (
            <Typography variant="body2" color="error">
                Notice: The candidate has a CV uploaded but it hasn't been parsed yet. Consider parsing the CV to enrich candidate data.
            </Typography>
        );
    }


    return null;
}